import { InvoicingComponent } from '../invoicing.component';
import { Component } from '@angular/core';
import ProjectInvoice from 'src/app/model/invoice/project-invoice';
import InvoiceHelper from 'src/app/helpers/invoice-helper';

@Component({
  selector: 'placement-invoice',
  templateUrl: '../invoicing.component.html',
  styleUrls: ['../invoicing.component.scss'],
})
export class PlacementInvoiceComponent extends InvoicingComponent {
  ngOnInit() {
    super.ngOnInit();
    this.canSendInvoices = this.project.products.every((p) => {
      return p.readyToInvoice;
    });
    this.init = true;
    this.anySentToTeamleader = InvoiceHelper.getAnySentToTeamleader(
      this.getMatchingInvoices()
    );
  }

  public getInvoiceType() {
    return 'PlacementInvoice';
  }

  public invoiceMatchesType(projectInvoice: ProjectInvoice) {
    return projectInvoice.type === 'PlacementInvoice';
  }
}
